module.exports = __webpack_public_path__ + "img/badge_rugzak_small.39e8e4a5.png";